import { Invoke } from '@swf/components/StarsWizard/Flow';
import type { FlowConfig } from '@swf/core/types/Wizard';

import RMFAddress from '../../components/RMFAddress/RMFAddress';
import RMFDepositLimit from '../../components/RMFDepositLimit/RMFDepositLimit';
import RMFPhone from '../../components/RMFPhone/RMFPhone';
import RMFPlayerFundsProtection from '../../components/RMFPlayerFundsProtection/RMFPlayerFundsProtection';

import useRMFBaseSteps from './../useRMFBaseSteps';
import { Service } from './../useRmfServices';
import useRmfUKBaseSteps from './useRmfUKBaseSteps';

const useRmfUKPhoneAfterAddressFlow = (): FlowConfig => {
  const { invokeLegalNameSave, invokeSignupDob, jumpToFeatureStep, forkDobCheck } =
    useRMFBaseSteps();
  const {
    forkVerification,
    invokeRetryEnableRealMoneyFlag,
    invokeDepositLimitSave,
    invokeEnableRealMoneyFlag,
    invokeUserDataSave,
    forkEKYCFailCheck,
    retryMarker
  } = useRmfUKBaseSteps();

  const invokeMobilePhoneSave = new Invoke(Service.RmfMobilePhoneSave, RMFDepositLimit, RMFPhone);
  const invokeAddressSave = new Invoke(Service.RmfAddressSave, RMFPhone, RMFAddress);

  return [
    invokeSignupDob,
    forkDobCheck,
    invokeLegalNameSave,
    RMFAddress,
    invokeAddressSave,
    RMFPhone,
    invokeMobilePhoneSave,
    RMFDepositLimit,
    invokeDepositLimitSave,
    RMFPlayerFundsProtection,
    invokeUserDataSave,
    invokeEnableRealMoneyFlag,
    retryMarker,
    forkEKYCFailCheck,
    invokeRetryEnableRealMoneyFlag,
    forkVerification,
    jumpToFeatureStep
  ];
};

export default useRmfUKPhoneAfterAddressFlow;
